import { FC } from "react";
import { FavoriteEntry } from "../../store/favorite";
import FavoriteListItem from "./FavoriteListItem";

type FavoriteListProps = {
    favoriteEntries: FavoriteEntry[];
    onDelete: (favoriteEntry: FavoriteEntry) => void;
};

const FavoriteList: FC<FavoriteListProps> = (props) => {
    const { favoriteEntries } = props;
    
    const handleOnFavoriteEntryDelete = (favoriteEntry: FavoriteEntry) => {
        props.onDelete(favoriteEntry);
    }
    
    return (
        <>
            <ul>
                {favoriteEntries.map((favoriteEntry, i) =>
                    <FavoriteListItem key={i} favoriteEntry={favoriteEntry} onDelete={handleOnFavoriteEntryDelete} />
                )}
            </ul>
        </>
    );
}

export default FavoriteList;